// extracted by mini-css-extract-plugin
export default {"editSheet":"FrameModals_editSheet__97lc6"};